import { render } from "./HeroiconsOutlineArrowLeft.vue?vue&type=template&id=4bd6e794"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowLeft.vue"]])

export default __exports__